/** Visibility rules for the live-session composer chip and empty state. */

export function isSupportThreadOpen(args: {
  supportThreadId?: string | null
  openThreadId?: string | null
}): boolean {
  const support = (args.supportThreadId || '').trim()
  const open = (args.openThreadId || '').trim()
  return Boolean(support && open && support === open)
}

export function isSupportChipVisible(args: {
  active: boolean
  sessionId?: string | null
  supportThreadId?: string | null
  openThreadId?: string | null
}): boolean {
  return Boolean(
    args.active &&
      args.sessionId &&
      isSupportThreadOpen({
        supportThreadId: args.supportThreadId,
        openThreadId: args.openThreadId,
      }),
  )
}

export function isListeningEmptyThread(args: {
  chipVisible: boolean
  messageCount: number
}): boolean {
  return args.chipVisible && args.messageCount === 0
}
